import React from 'react';

import Icon from '../Icon/Icon';

const ConfirmationIcon = (props) => {
    return (
        <Icon width='64' height='64' fill='none' {...props}>
            <g clipPath='url(#clip0_6111_14445)'>
                <path
                    d='M32 8.5C35.1311 8.5 37.7824 10.8341 40.5069 11.9646C43.2314 13.0951 46.8424 13.4041 48.9732 15.5268C51.104 17.6494 51.3643 21.171 52.5354 23.9931C53.7065 26.8151 56 29.3607 56 32.5C56 35.6393 53.6659 38.2824 52.5354 41.0069C51.4049 43.7314 51.0959 47.3424 48.9732 49.4732C46.8424 51.604 43.329 51.8643 40.5069 53.0354C37.6849 54.2065 35.1393 56.5 32 56.5C28.8607 56.5 26.2176 54.1659 23.4931 53.0354C20.7686 51.9049 17.1576 51.5959 15.0268 49.4732C12.896 47.3506 12.6357 43.829 11.4646 41.0069C10.2935 38.1849 8 35.6311 8 32.5C8 29.3689 10.3341 26.7176 11.4646 23.9931C12.5951 21.2686 12.9041 17.6576 15.0268 15.5268C17.1494 13.396 20.671 13.1357 23.4931 11.9646C26.3151 10.7935 28.8689 8.5 32 8.5Z'
                    fill='#00D1D2'
                />
                <path
                    d='M50.486 32.5001C50.486 42.7068 42.2068 50.986 32.0001 50.986C21.7934 50.986 13.5142 42.7068 13.5142 32.5001C13.5142 22.2934 21.7853 14.0142 32.0001 14.0142C42.2149 14.0142 50.486 22.2934 50.486 32.5001Z'
                    fill='#393E44'
                />
                <path
                    d='M22 32.5L29.107 39.6286L41 25'
                    stroke='#FFFDFB'
                    strokeWidth='2.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
            <defs>
                <clipPath id='clip0_6111_14445'>
                    <rect width='48' height='48' fill='white' transform='translate(8 8.5)' />
                </clipPath>
            </defs>
        </Icon>
    );
};

export default ConfirmationIcon;
